import Registry from 'live/services/registry'
import { FilterType } from '../types/types'

export type MetricParams = {
    selectedViewType: FilterType
    selectedJobIds?: string[]
    selectedCrewIds?: string[]
}

export type MetricRegistryItem = {
    id: string
    order: number
    component: React.ComponentType<{
        params: MetricParams
    }>
}
export const MetricsRegistry = new Registry<MetricRegistryItem>()
